import { sideNavigationState } from './state';

export default (placeholder) => ({
  state: sideNavigationState(placeholder),
  namespaced: true,
});
